function getRect(element) {
  return element.getBoundingClientRect();
}
function useRect(element) {
  if (!element) {
    return null;
  }

  // TODO: Update rect on scroll/resize

  return getRect(element);
}

export { useRect };
